import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Reset = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.29259 5.46177C6.37088 5.62055 6.23058 5.79933 6.05774 5.76103L3.14945 5.1165C3.01771 5.08731 2.94687 4.94365 3.00392 4.82136L4.2632 2.12178C4.33804 1.96134 4.56529 1.95888 4.64358 2.11766L5.11918 3.08214C5.42841 2.92679 5.74983 2.80018 6.07936 2.70319C6.78187 2.49642 7.52125 2.42421 8.25815 2.49492C9.43189 2.60755 10.5429 3.07734 11.4413 3.84095C12.3398 4.60457 12.9825 5.62529 13.2829 6.76552C13.5833 7.90575 13.5269 9.11066 13.1212 10.2178C12.7156 11.325 11.9802 12.2811 11.0143 12.9574C10.0484 13.6337 8.89835 13.9976 7.71922 14C6.54009 14.0024 5.38857 13.6432 4.4199 12.9709C3.65201 12.438 3.02829 11.7285 2.59838 10.9066C2.41149 10.5493 2.60826 10.1262 2.98631 9.98598C3.36436 9.84571 3.77944 10.0428 3.9815 10.3918C4.29715 10.9369 4.73016 11.4088 5.2525 11.7713C5.97585 12.2734 6.83573 12.5416 7.71623 12.5398C8.59673 12.538 9.45551 12.2662 10.1768 11.7612C10.8981 11.2562 11.4472 10.5422 11.7501 9.71546C12.053 8.8887 12.0952 7.98895 11.8709 7.1375C11.6466 6.28605 11.1666 5.52383 10.4957 4.95361C9.82476 4.38339 8.99515 4.03259 8.11867 3.94848C7.30668 3.87057 6.49064 4.02503 5.76501 4.39185L6.29259 5.46177Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Reset;
